<template>
  <div class="catalog-grid">
    <div class="catalog-grid__list">
      <BigPreloader
        v-if="appIsLoading"
        :caption="$t('home.catalog_grid.bigPreloader.caption')"
        :info="$t('home.catalog_grid.bigPreloader.info')"
      />
      <TabPlaceholder
        v-else-if="showPlaceholder"
        :caption="$t('home.catalog_grid.tabPlaceholder.caption')"
        :info="$t('home.catalog_grid.tabPlaceholder.info')"
      />
      <CatalogItem
        v-else
        v-for="model in sortedModels"
        :key="model.id"
        :item="model"
        :current-view-mode="currentViewMode"
      />
    </div>
    <div v-if="!appIsLoading" class="catalog-grid__footer">
      <create-fab />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import CatalogItem from './catalog_item'
import createFab from './create_fab'
import BigPreloader from '@/components/common/BigPreloader'
import TabPlaceholder from '@/components/common/TabPlaceholder'

export default {
  components: {
    CatalogItem,
    createFab,
    BigPreloader,
    TabPlaceholder
  },

  props: {
    currentViewMode: {
      type: String,
      default: 'mode-1'
    },
    sort: Object
  },

  computed: {
    ...mapState('knowledgebase', ['knowledgeBases', 'appIsLoading']),
    ...mapState('knowledgebase/customModels', ['customModels']),

    showPlaceholder () {
      return _.isEmpty(this.sortedModels) && !this.appIsLoading
    },

    sortedModels () {
      const sortModels = (models, reverse, byName) => {
        const sortedBy = _.sortBy(models, mdl => byName ? mdl.name.toLowerCase() : mdl.modifiedDate)
        return reverse ? sortedBy.reverse() : sortedBy
      }

      const sortOrder = this.sort.activeName ? this.sort.nameUp : this.sort.modifiedUp
      return sortModels([...this.knowledgeBases, ...this.customModels], sortOrder, this.sort.activeName)
    }
  }
}
</script>

<style lang="scss" scoped>
.catalog-grid {
  display: flex;
  position: relative;
  width: 100%;
  flex-direction: column;
  justify-content: space-between;
  align-content: flex-start;
  overflow-y: auto;
  transition: all 0.65s ease-in-out;

  &__footer {
    margin-top: auto;
    position: sticky;
    bottom: 0;
    padding: 16px;
    width: 100%;
  }

  &__list {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    justify-content: flex-start;
    padding: 16px 32px 32px;

    .grid-preloader {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
}
</style>

<style lang="scss">
.catalog-grid__footer > .create-fab {
  background: $or-blue;
}
</style>
